import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, useReducer } from 'react';
import { useKey } from 'react-use';
import { createAction } from 'typesafe-actions';
var OPEN = "OPEN";
var CLOSE = "CLOSE";
var NEXT = "NEXT";
var PREVIOUS = "PREVIOUS";

var _open = createAction(OPEN)();

var _close = createAction(CLOSE)();

var _next = createAction(NEXT)();

var _previous = createAction(PREVIOUS)();

var reducer = function reducer(state, action) {
  switch (action.type) {
    case OPEN:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: action.payload.active,
          opened: true
        });
      }

    case CLOSE:
      {
        if (state.opened) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active,
            opened: false
          });
        }

        return _objectSpread({}, state);
      }

    case NEXT:
      {
        if (state.opened && state.images.length - 1 > state.active) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active + 1,
            opened: true
          });
        }

        return _objectSpread({}, state);
      }

    case PREVIOUS:
      {
        if (state.opened && state.active > 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active - 1,
            opened: true
          });
        }

        return _objectSpread({}, state);
      }

    default:
      {
        return _objectSpread({}, state);
      }
  }
};

var DEFAULT_OPTIONS = {
  initialOpen: false,
  images: [],
  active: 0
};

var useLightbox = function useLightbox(options) {
  var settings = useMemo(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }, [options]);

  var _useReducer = useReducer(reducer, {
    active: settings.active,
    opened: settings.initialOpen,
    images: settings.images
  }),
      state = _useReducer[0],
      event = _useReducer[1];

  var active = state.active,
      opened = state.opened;
  useKey("Escape", function (e) {
    e.preventDefault();
    event(_close());
  }, undefined, [opened]);
  useKey("ArrowRight", function (e) {
    e.preventDefault();
    event(_next());
  }, undefined, [opened, settings.images, active]);
  useKey("ArrowLeft", function (e) {
    e.preventDefault();
    event(_previous());
  }, undefined, [opened, active]);
  return {
    opened: opened,
    open: function open(position) {
      event(_open({
        active: position
      }));
    },
    close: function close() {
      event(_close());
    },
    previous: function previous() {
      event(_previous());
    },
    next: function next() {
      event(_next());
    },
    images: settings.images,
    active: active
  };
};

export default useLightbox;